import {
  showDocumentModalRoutine,
  showHowItWorksModalRoutine,
  bookACallModalRoutine,
  SHOW_DOCUMENT_MODAL_CLEANUP,
  SHOW_HOW_IT_WORKS_MODAL_CLEANUP,
  BOOK_A_CALL_MODAL_CLEANUP
} from './routines'
import { logoutRoutine } from '@/store/modules/auth/routines'
import { state as initialState } from './index'

export default {
  [showDocumentModalRoutine.TRIGGER](context, payload) {
    context.commit(showDocumentModalRoutine.TRIGGER, payload)
  },

  [showHowItWorksModalRoutine.TRIGGER](context, payload) {
    context.commit(showHowItWorksModalRoutine.TRIGGER, payload)
  },

  [bookACallModalRoutine.TRIGGER](context, payload) {
    context.commit(bookACallModalRoutine.TRIGGER, payload)
  },

  [logoutRoutine.SUCCESS](context) {
    context.commit(SHOW_DOCUMENT_MODAL_CLEANUP, initialState)
    context.commit(SHOW_HOW_IT_WORKS_MODAL_CLEANUP, initialState)
    context.commit(BOOK_A_CALL_MODAL_CLEANUP, initialState)
  }
}
